module.exports = __webpack_public_path__ + "static/media/tommy_trojan.d1dab2c8.jpg";